var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareAFaceAttract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1790,
    height: 2223,
    viewBox: "0 0 1790 2223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M604.5 1209.62C938.141 1209.62 1208.38 1479.86 1208.38 1813.5C1208.38 2147.14 938.141 2417.38 604.5 2417.38C270.859 2417.38 0.625 2147.14 0.625 1813.5C0.625 1479.86 270.859 1209.62 604.5 1209.62ZM1813.5 1209.62C2147.14 1209.62 2417.38 1479.86 2417.38 1813.5C2417.38 2147.14 2147.14 2417.38 1813.5 2417.38C1479.86 2417.38 1209.62 2147.14 1209.62 1813.5C1209.62 1479.86 1479.86 1209.62 1813.5 1209.62ZM604.5 0.625C938.141 0.625 1208.38 270.859 1208.38 604.5C1208.38 938.141 938.141 1208.38 604.5 1208.38C270.859 1208.38 0.625 938.141 0.625 604.5C0.625 270.859 270.859 0.625 604.5 0.625ZM1813.5 0.625C2147.14 0.625 2417.38 270.859 2417.38 604.5C2417.38 938.141 2147.14 1208.38 1813.5 1208.38C1479.86 1208.38 1209.62 938.141 1209.62 604.5C1209.62 270.859 1479.86 0.625 1813.5 0.625Z",
    stroke: "white",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareAFaceAttract);
export default __webpack_public_path__ + "static/media/compare-a-face-attract.85b1431dd4bdaab18cbb2f1a70b75347.svg";
export { ForwardRef as ReactComponent };